import { render, staticRenderFns } from "./centerT-temp3.vue?vue&type=template&id=6a807b10&scoped=true"
import script from "./centerT-temp3.vue?vue&type=script&lang=js"
export * from "./centerT-temp3.vue?vue&type=script&lang=js"
import style0 from "./centerT-temp3.vue?vue&type=style&index=0&id=6a807b10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a807b10",
  null
  
)

export default component.exports